<template>
  <section class="gallery-section">
    <UContainer class="gallery-section__container">
      <SPGallerySectionHeader
        class="mb-10 max-lg:mb-7 max-md:mb-5"
        :current="images?.length < perView ? images.length : perView"
        :total="images?.length"
        :per-view="3"
        :is-start="swiperInstance?.isBeginning"
        :is-end="swiperInstance?.isEnd"
        @prev="swiperInstance?.slidePrev()"
        @next="swiperInstance?.slideNext()"
      />

      <Swiper
        :slides-per-view="perView"
        :space-between="20"
        @swiper="swiperInstance = $event"
      >
        <SwiperSlide v-for="(slide, index) in images" :key="index">
          <img
            class="rounded-[16px] h-75 w-full object-cover object-center"
            :src="slide.url"
            alt="Изображение галереи"
            @click="() => showLightbox(index)"
          />
        </SwiperSlide>
      </Swiper>

      <VueEasyLightbox
        :visible="isLightboxVisible"
        :imgs="imageUrls"
        :index="lightboxIndex"
        @hide="onLightboxClose"
      />
    </UContainer>
  </section>
</template>

<script lang="ts" setup>
import type { CatalogAttachment } from '~/api'
import SPGallerySectionHeader from './SPGallerySectionHeader.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import type { SwiperClass } from 'swiper/react'

defineOptions({
  name: 'SPGallerySection',
})

const props = withDefaults(
  defineProps<{
    images: CatalogAttachment[]
    perView: number
    title?: string
    current?: number
  }>(),
  {
    title: 'Галерея',
    current: 3,
  },
)

const swiperInstance = ref<SwiperClass | null>(null)
const isLightboxVisible = ref(false)
const lightboxIndex = ref(0)

const imageUrls = computed(() => props.images.map((i) => i.url))

const showLightbox = (index: number) => {
  lightboxIndex.value = index
  isLightboxVisible.value = true
}

const onLightboxClose = () => {
  isLightboxVisible.value = false
  lightboxIndex.value = 0
}
</script>

<style lang="scss" scoped>
:deep(.vel-modal) {
  background: var(--background-bg-overlay, #222429b2);
}

:deep(.vel-img) {
  border-radius: 24px;
}

:deep(.vel-toolbar) {
  display: none;
}

:deep(.ring) {
  border-color: transparent;
}

:deep(.vel-btns-wrapper) {
  display: none;
}
</style>
